import { Queue } from '@cian/event-queue';

import { TEvents } from '../../types/events';

/**
 * Возвращает общую очередь событий.
 *
 * На клиенте это синглтон `window.eventQueue`, в который пишет микрофронтенд рекламных баннеров;
 * если его ещё нет, очередь создаётся и кешируется обратно в `window`, чтобы хост и микрофронтенд
 * работали с одним и тем же инстансом. Вне клиента возвращается отдельная пустая очередь.
 */
export function getEventQueue(): Queue<TEvents> {
  if (typeof window !== 'undefined') {
    return window.eventQueue || (window.eventQueue = new Queue<TEvents>());
  }

  return new Queue<TEvents>();
}
